import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, ErrorMessage } from "formik";
import { useStyles } from "../styles";
import * as Yup from "yup";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography, Select, MenuItem
} from "@mui/material";

import useInstitution from "../../../../Hooks/institution";
import Loader from "../../../../common/Loader";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { useEffect } from "react";
const number =
  /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
const institutionListSchema = Yup.object().shape({
  endDate: Yup.date()
    .when("startDate", (startDate, schema) => {
      console.log("startDate", startDate, schema);
      if (startDate) {
        const dayAfter = new Date(startDate.getTime());
        return schema.min(
          dayAfter,
          "* Date range looks incorrect"
          // "* The 'To' date cannot be earlier than the 'From' date. Please select a valid date range."
        );
      }
      return schema;
    })
    .required("* please enter the to date")
    .nullable(),
  startDate: Yup.date()
    .required("* please enter the from date")
    .nullable(),
  name: Yup.string().required("* Please enter name"),
  emailId: Yup.string().email().required("* Please enter email "),
  mobileNumber: Yup.string()
    .matches(number, "please enter a valid")
    .max(10)
    .required("*Please enter phone number"),
  address: Yup.string(),
  migrationMonth: Yup.string().required("* Please choose migration month"),
});

const Months = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
]

const UpdateInstitution = () => {
  const classes = useStyles();
  const { updateInstitutionAction, loading, redirect } = useInstitution();

  const navigate = useNavigate();
  const location = useLocation();
  const date = new Date(location.state.createdAt);

  const minDate = new Date("01/01/1950");

  const initValues = {
    mobileNumber: location.state.mobileNumber,
    emailId: location.state.emailId,
    address: location.state.address,
    name: location.state.name,
    id: location.state.id,
    startDate: location.state.startDate,
    endDate: location.state.endDate,
    migrationMonth: location.state.migrationMonth === 0 ? "" : location.state.migrationMonth,
    // emailId: "",
    //   mobileNumber: "",
    //   address: "",
    //   name: "",
  };
  useEffect(() => {
    if (redirect) {
      navigate("/institution");
    }
  }, [redirect]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Stack className={classes.arrival}>
          <Grid container>
            <Grid item lg={10} xl={10} sm={12}>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    p: 4,
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Typography
                    sx={{ py: 2 }}
                    className={classes.add_course_text}
                  >
                    Update Institution
                  </Typography>
                  <Grid item lg={8} sm={12}>
                    <Stack>
                      <Formik
                        initialValues={initValues}
                        validateOnBlur={false}
                        validateOnChange={false}
                        validationSchema={institutionListSchema}
                        onSubmit={(values, { resetForm }) => {
                          updateInstitutionAction(values);
                        }}
                      >
                        {(formik) => {
                          const {
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            values,
                          } = formik;
                          return (
                            <form onSubmit={handleSubmit}>
                              {/* {loading? (<div><Loader /></div>):(  */}
                              <div>
                                {/* {JSON.stringify(errors)} */}
                                <Grid
                                  container
                                  sx={{ py: 2 }}
                                  className={classes.form_add_course}
                                  spacing={6}
                                >
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 350

                                      }}
                                    >
                                      <Stack>
                                        <Typography className={classes.label} sx={{ width: 100, marginLeft: 1 }}>
                                          Name
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          id="name"
                                          name="name"
                                          placeholder="Enter name"
                                          className={
                                            errors.name && touched.name
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.name}
                                        />
                                        <ErrorMessage
                                          name="name"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 450
                                      }}
                                    >
                                      <Stack>
                                        <Typography className={classes.label} sx={{ width: 100, marginLeft: 14 }}>
                                          Email
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          id="emailId"
                                          type="email"
                                          name="emailId"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.emailId}
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          placeholder="Enter email"
                                        />
                                        <ErrorMessage
                                          name="emailId"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  sx={{ pb: 2 }}
                                  className={classes.form_add_course}
                                  spacing={4}
                                >
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 350
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                          sx={{ width: 100, marginLeft: 1 }}

                                        >
                                          Mobile
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          id="mobileNumber"
                                          name="mobileNumber"
                                          type="number"
                                          placeholder="Enter mobile"
                                          className={
                                            errors.mobileNumber &&
                                              touched.mobileNumber
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.mobileNumber}
                                        />
                                        <ErrorMessage
                                          name="mobileNumber"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 460
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                          sx={{ width: 100, marginLeft: 15 }}
                                        >
                                          Address
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          id="address"
                                          name="address"
                                          placeholder="Enter address"
                                          className={
                                            errors.address && touched.address
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.address}
                                        />
                                        <ErrorMessage
                                          name="address"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  sx={{ pb: 2 }}
                                  className={classes.form_add_course}
                                  spacing={4}
                                >
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 350
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                          sx={{ width: 100, marginLeft: 1 }}
                                        >
                                          From
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          sx={{
                                            width: "250px",
                                          }}
                                          id="startDate"
                                          type="date"
                                          name="startDate"
                                          placeholder="Enter Date From"
                                          className={
                                            errors.startDate &&
                                              touched.startDate
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.startDate}
                                        />
                                        <ErrorMessage
                                          name="startDate"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 460
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                          sx={{ width: 100, marginLeft: 15 }}
                                        >
                                          to
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <TextField
                                          sx={{
                                            width: "250px",
                                          }}
                                          id="endDate"
                                          type="date"
                                          name="endDate"
                                          placeholder="Enter Date To"
                                          className={
                                            errors.endDate && touched.endDate
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.endDate}
                                        />
                                        <ErrorMessage
                                          name="endDate"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  sx={{ pb: 2 }}
                                  className={classes.form_add_course}
                                  spacing={4}
                                >
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: 350
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                          sx={{ width: 100, marginLeft: 1 }}
                                        >
                                          Migration Month
                                        </Typography>
                                      </Stack>
                                      <Stack>
                                        <Select
                                          id="migrationMonth"
                                          name="migrationMonth"
                                          className={
                                            errors.migrationMonth && touched.migrationMonth
                                              ? classes.inputError
                                              : classes.inputNoError
                                          }
                                          value={values.migrationMonth}
                                          onChange={handleChange}
                                          IconComponent={CustomExpandMore}
                                          sx={{
                                            width: "250px",
                                            display: "flex",
                                          }}
                                          displayEmpty
                                        >
                                          <MenuItem disabled value="">
                                            <span>Select Migration Month</span>
                                          </MenuItem>
                                          {Months?.map((month) => (
                                            <MenuItem value={month.id}>
                                              {month.name}
                                            </MenuItem>
                                          ))
                                          }
                                        </Select>
                                        <ErrorMessage
                                          name="migrationMonth"
                                          component="span"
                                          className={classes.error}
                                        />
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  sx={{ pb: 2, justifyContent: "flex-end" }}
                                  className={classes.form_add_course}
                                  spacing={4}
                                >
                                  <Grid item md={6} sx={{ width: "100%" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Stack>
                                        <Typography
                                          className={classes.label}
                                        ></Typography>
                                      </Stack>
                                      <Stack>
                                        <Button
                                          type="submit"
                                          sx={{
                                            px: 1,
                                            py: 1.5,
                                            borderRadius: "50px",
                                            width: "220px",
                                            marginLeft: 30,
                                          }}
                                          className={classes.add_arrival}
                                        >
                                          Update
                                        </Button>
                                      </Stack>
                                    </Stack>
                                  </Grid>
                                </Grid>
                              </div>
                              {/* )} */}
                            </form>
                          );
                        }}
                      </Formik>
                    </Stack>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      )}
    </>
  );
};

export default UpdateInstitution;
